/* Filteren en sorteren op de collectiepagina. Alles gebeurt in de browser, zonder herladen.
   De kaarten dragen hun kenmerken als data attributen; de tellers per filter worden hier berekend.
   De filters staan in een zijbalk (op mobiel een lade) met uitklapbare groepen. */
(function () {
  var root = document.querySelector('[data-ec]');
  if (!root) return;

  var grid = root.querySelector('[data-ec-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ec-card]'));
  if (!grid || !cards.length) return;

  var count = root.querySelector('[data-ec-count]');
  var leeg = root.querySelector('[data-ec-empty]');
  var sort = root.querySelector('[data-ec-sort]');
  var side = root.querySelector('[data-ec-side]');
  var overlay = root.querySelector('[data-ec-overlay]');
  var open = root.querySelector('[data-ec-open]');
  var actief = root.querySelector('[data-ec-active]');
  var resetSide = root.querySelector('[data-ec-reset-side]');
  var apply = root.querySelector('[data-ec-apply]');
  var groepen = Array.prototype.slice.call(root.querySelectorAll('[data-ec-group]'));
  var meer = root.querySelector('[data-ec-more]');
  var bijladen = root.hasAttribute('data-ec-bijladen');
  var allesGeladen = !meer;
  var bezigMetLaden = false;
  var promo = grid.querySelector('[data-ec-promo]');
  var promoNa = promo ? (parseInt(promo.getAttribute('data-ec-promo'), 10) || 6) : 0;
  var GROEPEN = ['maat', 'kleur', 'soort', 'merk', 'hardheid', 'vering', 'prijsgroep', 'voordeel'];
  var woord = root.getAttribute('data-ec-noun') || 'producten';
  var totaal = parseInt(root.getAttribute('data-ec-totaal'), 10) || 0;
  var paginas = parseInt(root.getAttribute('data-ec-paginas'), 10) || 1;
  var mobiel = window.matchMedia('(max-width: 999px)');

  function inputs(groep) {
    return Array.prototype.slice.call(root.querySelectorAll('input[data-ec-filter="' + groep + '"]'));
  }
  function gekozen(groep) {
    return inputs(groep).filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
  }
  function heeft(card, groep, waarde) {
    return (card.getAttribute('data-' + groep) || '').split('|').indexOf(waarde) !== -1;
  }
  function past(card, negeer) {
    for (var g = 0; g < GROEPEN.length; g++) {
      var groep = GROEPEN[g];
      if (groep === negeer) continue;
      var wil = gekozen(groep);
      if (!wil.length) continue;
      var raak = false;
      for (var i = 0; i < wil.length; i++) { if (heeft(card, groep, wil[i])) { raak = true; break; } }
      if (!raak) return false;
    }
    return true;
  }

  // tellers: hoeveel producten zou dit filter opleveren, gegeven de andere gekozen filters
  function tellers() {
    root.querySelectorAll('[data-ec-count-for]').forEach(function (el) {
      var delen = el.getAttribute('data-ec-count-for').split(':');
      var groep = delen[0], waarde = delen[1], n = 0;
      cards.forEach(function (c) { if (heeft(c, groep, waarde) && past(c, groep)) n++; });
      el.textContent = n;
      var opt = el.closest('.ec-opt, .ec-sz');
      if (opt) opt.classList.toggle('is-zero', n === 0);
    });
  }

  function labelVan(input) {
    var lbl = input.parentNode.querySelector('.ec-lbl') || input.parentNode.querySelector('.ec-sz__t') || input.parentNode.querySelector('span');
    return lbl ? lbl.childNodes[0].textContent.trim() : input.value;
  }

  function tags() {
    if (!actief) return;
    actief.innerHTML = '';
    var totaal = 0;
    GROEPEN.forEach(function (groep) {
      inputs(groep).forEach(function (i) {
        if (!i.checked) return;
        totaal++;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ec-tag';
        b.setAttribute('aria-label', 'Filter verwijderen: ' + labelVan(i));
        b.innerHTML = '<span></span><i aria-hidden="true">×</i>';
        b.firstChild.textContent = labelVan(i);
        b.addEventListener('click', function () { i.checked = false; teken(); });
        actief.appendChild(b);
      });
    });
    if (open) {
      open.classList.toggle('has-active', totaal > 0);
      var dot = open.querySelector('.ec-dot'); if (dot) dot.textContent = totaal;
    }
    if (resetSide) resetSide.hidden = totaal === 0;
    // per groep: hoeveel gekozen, als badge op de knop
    groepen.forEach(function (g) {
      var n = g.querySelectorAll('input[data-ec-filter]:checked').length;
      var badge = g.querySelector('[data-ec-group-n]');
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
      g.classList.toggle('has-sel', n > 0);
    });
  }

  // het blok tussen de kaarten staat na de zoveelste zichtbare kaart
  function zetPromo() {
    if (!promo) return;
    var zicht = cards.filter(function (c) { return !c.hidden; });
    if (!zicht.length) { promo.hidden = true; return; }
    promo.hidden = false;
    var doel = zicht[promoNa - 1];
    if (doel) { if (doel.nextSibling !== promo) grid.insertBefore(promo, doel.nextSibling); }
    else if (grid.lastChild !== promo) grid.appendChild(promo);
  }

  function teken() {
    var zichtbaar = 0;
    cards.forEach(function (c) { var ok = past(c); c.hidden = !ok; if (ok) zichtbaar++; });
    if (count) {
      if (bijladen) {
        var noemer = allesGeladen ? cards.length : totaal;
        count.innerHTML = '<b>' + zichtbaar + '</b><span class="ec-count-van"> van ' + noemer + '</span> ' + woord;
      } else if (paginas > 1) {
        count.innerHTML = '<b>' + zichtbaar + '</b> van ' + cards.length + ' op deze pagina<span class="ec-count-van"> · ' + totaal + ' ' + woord + ' in totaal</span>';
      } else {
        count.innerHTML = '<b>' + zichtbaar + '</b><span class="ec-count-van"> van ' + cards.length + '</span> ' + woord;
      }
    }
    if (leeg) leeg.hidden = zichtbaar !== 0;
    if (apply) apply.textContent = (apply.getAttribute('data-ec-apply') || 'Toon resultaten') + ' (' + zichtbaar + ')';
    root.querySelectorAll('.ec-sz').forEach(function (s) { var i = s.querySelector('input'); s.classList.toggle('is-on', !!(i && i.checked)); });
    tellers();
    tags();
    zetPromo();
  }

  function sorteer(hoe) {
    var lijst = cards.slice();
    lijst.sort(function (a, b) {
      var pa = parseFloat(a.getAttribute('data-prijs')) || 0, pb = parseFloat(b.getAttribute('data-prijs')) || 0;
      if (hoe === 'prijs-op') return pa - pb;
      if (hoe === 'prijs-af') return pb - pa;
      if (hoe === 'korting') return (parseInt(b.getAttribute('data-korting'), 10) || 0) - (parseInt(a.getAttribute('data-korting'), 10) || 0);
      if (hoe === 'naam') return (a.getAttribute('data-naam') || '').localeCompare(b.getAttribute('data-naam') || '', 'nl');
      return (parseInt(a.getAttribute('data-volgorde'), 10) || 0) - (parseInt(b.getAttribute('data-volgorde'), 10) || 0);
    });
    lijst.forEach(function (c) { grid.appendChild(c); });
    zetPromo();
  }

  // filtergroepen open en dicht
  function zetGroep(g, openen) {
    g.classList.toggle('is-open', openen);
    var b = g.querySelector('[data-ec-group-btn]'); if (b) b.setAttribute('aria-expanded', openen ? 'true' : 'false');
  }
  groepen.forEach(function (g) {
    var b = g.querySelector('[data-ec-group-btn]'); if (!b) return;
    b.addEventListener('click', function () { zetGroep(g, !g.classList.contains('is-open')); });
    zetGroep(g, g.getAttribute('data-ec-open-start') === '1');
  });

  // lade op mobiel
  function zetLade(openen) {
    if (!side) return;
    side.classList.toggle('is-open', openen);
    if (overlay) overlay.classList.toggle('is-open', openen);
    if (open) open.setAttribute('aria-expanded', openen ? 'true' : 'false');
    if (mobiel.matches) document.documentElement.classList.toggle('ec-lock', openen);
    if (openen) { var eerste = side.querySelector('input, button'); if (eerste) eerste.focus({ preventScroll: true }); }
    else if (open && document.activeElement && side.contains(document.activeElement)) { open.focus({ preventScroll: true }); }
  }
  if (open) open.addEventListener('click', function () { zetLade(!side.classList.contains('is-open')); });
  root.querySelectorAll('[data-ec-close]').forEach(function (b) { b.addEventListener('click', function () { zetLade(false); }); });
  if (overlay) overlay.addEventListener('click', function () { zetLade(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side && side.classList.contains('is-open')) zetLade(false); });
  mobiel.addEventListener('change', function () { if (!mobiel.matches) { document.documentElement.classList.remove('ec-lock'); zetLade(false); } });

  // ---------- meer producten bijladen ----------
  // De knop is een gewone link naar de volgende pagina, zodat hij ook zonder javascript werkt en Google hem volgt.
  // Met javascript halen we die pagina op, plakken de kaarten onderaan en laten de knop doorwijzen naar de pagina daarna.
  function kaartenOpnieuw() { cards = Array.prototype.slice.call(root.querySelectorAll('[data-ec-card]')); }
  // Alleen deze sectie ophalen (Shopify section rendering), ongeveer half zo groot als de hele pagina. Lukt dat niet, dan de hele pagina.
  var sectie = root.closest('.shopify-section');
  var sectieId = sectie && sectie.id ? sectie.id.replace(/^shopify-section-/, '') : '';
  var meerTekst = meer ? meer.textContent : '';
  function haal(href) {
    function volledig() { return fetch(href, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }); }
    if (!sectieId) return volledig();
    var u = new URL(href, window.location.href);
    u.searchParams.set('section_id', sectieId);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return html.indexOf('data-ec-card') > -1 ? html : volledig(); }, volledig);
  }
  function plakKaarten(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nieuw = doc.querySelectorAll('[data-ec-grid] [data-ec-card]');
    var basis = cards.length;
    Array.prototype.forEach.call(nieuw, function (c, i) {
      var kopie = document.importNode(c, true);
      kopie.setAttribute('data-volgorde', basis + i + 1);
      grid.appendChild(kopie);
    });
    kaartenOpnieuw();
    return doc;
  }
  function knopBezig(aan) {
    if (!meer) return;
    meer.classList.toggle('is-bezig', aan);
    meer.textContent = aan ? 'Bezig met laden' : meerTekst;
  }
  function klaarMetLaden() {
    allesGeladen = true;
    if (meer && meer.parentNode) meer.parentNode.removeChild(meer);
    meer = null;
  }
  function naLaden() {
    teken();
    if (sort && sort.value !== 'aanbevolen') sorteer(sort.value);
  }
  var lopend = null;
  function laadVolgende() {
    if (!meer) return Promise.resolve(false);
    if (lopend) return lopend;
    knopBezig(true);
    lopend = haal(meer.href)
      .then(function (html) {
        var volgende = plakKaarten(html).querySelector('[data-ec-more]');
        if (volgende) { meer.setAttribute('href', volgende.getAttribute('href')); knopBezig(false); }
        else { klaarMetLaden(); }
        naLaden();
        return true;
      })
      .catch(function () { knopBezig(false); return false; })
      .then(function (ok) { lopend = null; return ok; });
    return lopend;
  }
  // Filteren en sorteren hebben de hele collectie nodig: de resterende pagina's tegelijk ophalen en in volgorde plakken.
  // Mislukt dat, dan pagina voor pagina zoals voorheen.
  function opVolgorde() {
    if (allesGeladen || !meer) return Promise.resolve();
    return laadVolgende().then(function (ok) { return ok ? opVolgorde() : undefined; });
  }
  var allesBelofte = null;
  function zorgVoorAlles() {
    if (allesGeladen || !bijladen) return Promise.resolve();
    if (allesBelofte) return allesBelofte;
    allesBelofte = (lopend || Promise.resolve()).then(function () {
      if (allesGeladen || !meer) return;
      var u = new URL(meer.href, window.location.href);
      var van = parseInt(u.searchParams.get('page'), 10);
      if (!van || !(paginas >= van)) return opVolgorde();
      var urls = [];
      for (var p = van; p <= paginas; p++) { u.searchParams.set('page', p); urls.push(u.toString()); }
      knopBezig(true);
      return Promise.all(urls.map(haal)).then(function (htmls) {
        htmls.forEach(plakKaarten);
        klaarMetLaden();
        naLaden();
      }, function () { knopBezig(false); return opVolgorde(); });
    }).then(function () { allesBelofte = null; });
    return allesBelofte;
  }
  if (meer) { meer.addEventListener('click', function (e) { e.preventDefault(); laadVolgende(); }); }

  // sorteren: binnen de pagina als alles op een pagina staat, anders via de url zodat de hele collectie meegaat
  var sortUrl = sort && sort.hasAttribute('data-ec-sorturl');
  var SORTSLEUTEL = { aanbevolen: 'manual', 'prijs-op': 'price-ascending', 'prijs-af': 'price-descending', naam: 'title-ascending' };
  root.addEventListener('change', function (e) {
    if (e.target.matches('input[data-ec-filter]')) {
      if (!allesGeladen) { zorgVoorAlles().then(teken); } else { teken(); }
    }
    if (sort && e.target === sort) {
      if (sortUrl) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', SORTSLEUTEL[sort.value] || 'manual');
        u.searchParams.delete('page');
        window.location.href = u.toString();
      } else if (!allesGeladen) {
        zorgVoorAlles().then(function () { sorteer(sort.value); });
      } else {
        sorteer(sort.value);
      }
    }
  });

  root.querySelectorAll('[data-ec-reset]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('input[data-ec-filter]').forEach(function (i) { i.checked = false; });
      if (sort) { sort.value = 'aanbevolen'; sorteer('aanbevolen'); }
      teken();
    });
  });

  // de balk blijft op zijn plek zodra hij de kop raakt. Vaste positie via script, want een
  // bovenliggend element met overflow zet css sticky buiten spel. Volgt ook een kop die inschuift.
  var bar = root.querySelector('.ec-toolbar');
  var ruimte = null, vast = false;
  function kopOnder() {
    var top = 0;
    var tb = document.querySelector('.ela-topbar'); if (tb) top = Math.max(top, tb.getBoundingClientRect().bottom);
    var hdr = document.getElementById('ela-hdr'); if (hdr) top = Math.max(top, hdr.getBoundingClientRect().bottom);
    return Math.max(0, Math.round(top));
  }
  // op desktop scrolt div.page-wrapper, die zelf onder de vaste topbalk begint. Sticky meet vanaf de
  // scroller, dus de afstand tot de scrollerrand is de juiste waarde, anders telt de topbalk dubbel.
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 10) return pw;
    return null;
  }
  function plak() {
    var top = kopOnder();
    var sc = scroller();
    var basis = sc ? Math.max(0, Math.round(sc.getBoundingClientRect().top)) : 0;
    root.style.setProperty('--ec-sticky-top', Math.max(0, top - basis) + 'px');
    if (!bar) return;
    if (!ruimte) { ruimte = document.createElement('div'); ruimte.className = 'ec-toolbar-ruimte'; bar.parentNode.insertBefore(ruimte, bar); }
    var anker = vast ? ruimte : bar;
    var moet = anker.getBoundingClientRect().top <= top;
    if (moet && !vast) { ruimte.style.height = bar.offsetHeight + 'px'; bar.classList.add('is-fixed'); vast = true; }
    else if (!moet && vast) { bar.classList.remove('is-fixed'); ruimte.style.height = '0px'; vast = false; }
    if (vast) { var w = ruimte.getBoundingClientRect(); bar.style.top = top + 'px'; bar.style.left = w.left + 'px'; bar.style.width = w.width + 'px'; }
    else { bar.style.top = ''; bar.style.left = ''; bar.style.width = ''; }
  }
  var bezig = false;
  function bijScroll() { if (bezig) return; bezig = true; requestAnimationFrame(function () { plak(); bezig = false; }); }
  // op desktop scrolt het thema in div.page-wrapper en niet in het venster; capture op document vangt beide
  document.addEventListener('scroll', bijScroll, { passive: true, capture: true });
  window.addEventListener('scroll', bijScroll, { passive: true });
  window.addEventListener('resize', function () { if (vast) ruimte.style.height = bar.offsetHeight + 'px'; plak(); });
  plak();

  // maatkeuze op de kaart: variant, knop en prijs volgen de keuze
  root.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-ec-size]')) return;
    var comp = sel.closest('quick-add-component'); if (!comp) return;
    var input = comp.querySelector('input[name="id"]');
    var knop = comp.querySelector('.quick-add__button--add');
    var opt = sel.options[sel.selectedIndex];
    var keuze = sel.value;
    if (input) { input.value = keuze; input.disabled = !keuze; }
    if (knop) knop.disabled = !keuze;
    var kaart = sel.closest('[data-ec-card]');
    var rij = kaart && kaart.querySelector('.ec-price');
    if (!rij) return;
    var prijs = rij.querySelector('b'), van = rij.querySelector('.ec-from'), streep = rij.querySelector('s');
    if (keuze && opt) {
      prijs.textContent = opt.getAttribute('data-prijs');
      var oud = opt.getAttribute('data-van');
      if (oud) { if (!streep) { streep = document.createElement('s'); rij.appendChild(streep); } streep.textContent = oud; streep.hidden = false; }
      else if (streep) { streep.hidden = true; }
      if (van) van.hidden = true;
    } else {
      // terug naar de vanafprijs van het product
      prijs.textContent = rij.getAttribute('data-basis');
      var basisVan = rij.getAttribute('data-basis-van');
      if (streep) { if (basisVan) { streep.textContent = basisVan; streep.hidden = false; } else { streep.hidden = true; } }
      if (van) van.hidden = rij.getAttribute('data-varieert') !== '1';
    }
    // Klarna 3 termijnen volgt de gekozen maat; buiten 250 tot 2.999,99 verdwijnt de regel
    var kl = kaart.querySelector('[data-ec-kl]');
    if (kl) {
      var eur = parseFloat((keuze && opt ? opt.getAttribute('data-prijs') : rij.getAttribute('data-basis')) || '0');
      var ok = eur >= 250 && eur <= 2999.99;
      kl.hidden = !ok;
      if (ok) {
        kl.querySelector('[data-ec-kl-bedrag]').textContent = (Math.floor(eur * 100 / 3) / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, ',-');
        var vf = kl.querySelector('[data-ec-kl-vanaf]'); if (vf) vf.hidden = !!keuze;
      }
    }
  });

  teken();
})();
